<div id="main-page">

	<div class="header-text with-space">{{ checklistCreationDate | localizedDate | async }}</div>

	<div class="header-text">Number Ref. {{ order.orderNumber }}</div>
	<div class="header-text">
		Certification:
		@for (product of order.products; track $index) {
			{{ product.standard.name | standardName: true }} {{ getProcessTypeForProduct(product) }};
		}
		Accreditation marks: ANAB
	</div>
	<div class="header-text with-space">Audit type: {{ processType }}</div>

	<div class="address-text">{{ order.company.name }}</div>
	<div class="address-text">{{ order.company.street }}, {{ order.company.zipCode }}, {{ order.company.city }}, {{ order.company.state }}, {{ order.company.country }}</div>
	<div class="address-text with-space">{{ order.contactPerson.firstName }}, {{ order.contactPerson.lastName }}, {{ order.contactPerson.email }}
		, {{ order.contactPerson.countryCode }} {{ order.contactPerson.phoneNumber }}
	</div>

	@if (checklist.declineDate) {
		<div class="declined-header">Application declined</div>
		<div class="comment with-space">Reason for declining: {{ declineReason }}</div>
	}

	@for (questionGroup of checklist.questionGroups; track questionGroup.type) {
		<div class="question-group-title with-space">{{ questionGroup | toGroupName }}</div>
		@for (question of questionGroup.questions; track question.type) {
			<div class="question-explanation with-space" [innerHTML]="getQuestionExplanation(question)"></div>
			<div class="with-space">
				<div class="question-answers">
					@for (answer of question.answers; track answer; let isFirst = $first) {
						@if (!isFirst) {
							|
						}
						{{ answer.standardName | standardName }} - {{ toAnswer(answer.answer) }}
					}
				</div>
			</div>
			@if (question.comment) {
				<div class="comment with-space">Comment: {{ question.comment }}</div>
			}
		}
	}

</div>
